import React, { useState } from "react";
import SiderUser from "../../components/siderbarcomponentsUser";
import { useNavigate } from "react-router-dom";
import {
  AiOutlineArrowUp,
  AiOutlineArrowDown,
  AiOutlineDownload,
} from "react-icons/ai";

interface Factura {
  numero: string;
  fecha: string;
  estado: string;
  cantidad: string;
  suscripcion: string;
}

const SuscripcionTransaccion: React.FC = () => {
  const [facturas, setFacturas] = useState<Factura[]>([
    {
      numero: "#1023",
      fecha: "31 de Mayo de 2025",
      estado: "Pagado",
      cantidad: "$49.900",
      suscripcion: "Mensual",
    },
    {
      numero: "#1022",
      fecha: "31 de Abril de 2025",
      estado: "Pagado",
      cantidad: "$49.900",
      suscripcion: "Mensual",
    },
    {
      numero: "#1021",
      fecha: "30 de Marzo de 2025",
      estado: "Pagado",
      cantidad: "$49.900",
      suscripcion: "Mensual",
    },
    {
      numero: "#1020",
      fecha: "28 de Feb de 2025",
      estado: "Cancelado",
      cantidad: "$49.900",
      suscripcion: "Mensual",
    },
    {
      numero: "#1019",
      fecha: "31 de Enero de 2025",
      estado: "Pagado",
      cantidad: "$49.900",
      suscripcion: "Mensual",
    },
    {
      numero: "#1018",
      fecha: "31 de Diciembre de 2024",
      estado: "Pagado",
      cantidad: "$49.900",
      suscripcion: "Mensual",
    },
    {
      numero: "#1018",
      fecha: "31 de Diciembre de 2024",
      estado: "Pagado",
      cantidad: "$49.900",
      suscripcion: "Mensual",
    },
    {
      numero: "#1018",
      fecha: "31 de Diciembre de 2024",
      estado: "Pagado",
      cantidad: "$49.900",
      suscripcion: "Mensual",
    },
  ]);

  const [sortConfig, setSortConfig] = useState<{
    key: keyof Factura;
    direction: "asc" | "desc";
  } | null>(null);

  const sortData = (key: keyof Factura) => {
    let direction: "asc" | "desc" = "asc";
    if (
      sortConfig &&
      sortConfig.key === key &&
      sortConfig.direction === "asc"
    ) {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sortedData = [...facturas].sort((a, b) => {
      if (a[key] < b[key]) return direction === "asc" ? -1 : 1;
      if (a[key] > b[key]) return direction === "asc" ? 1 : -1;
      return 0;
    });
    setFacturas(sortedData);
  };
  const navigate = useNavigate();

  return (
    <div className="flex h-screen bg-gray-100">
      <SiderUser />

      <div className="p-8 bg-gray-100 min-h-screen w-full">
        <div className="bg-white shadow-lg rounded-lg pt-12 px-28 w-full h-[100%]">
          <h1 className="text-[22px] font-semibold text-textSubtitle mb-8">
            Configuración de mi cuenta
          </h1>

          <div className="flex items-center justify-between mb-2">
            <div>
              <ul className="flex space-x-4">
                <li
                  onClick={() => navigate("/user/suscripcion")}
                  className="cursor-pointer pb-2 text-[16px] font-medium text-textSubtitle mr-2"
                >
                  Perfil
                </li>
                <li className="border-b-4 border-blue-500 cursor-pointer pb-2 text-[16px] font-medium text-textTipic">
                  Suscripción
                </li>
              </ul>
            </div>
            <div className="flex items-center justify-center border border-gray-400 w-52 h-16 rounded-lg cursor-pointer">
              <h2 className="text-[16px] font-semibold text-textTipic">
                Suba su Logo
              </h2>
            </div>
          </div>

          <div className="border border-gray-300 rounded-md p-4 w-3/4 mb-8">
            <h3 className="text-[18px] font-semibold text-textSubtitle mb-2">
              Plan: Mensual
            </h3>
            <p className="mb-4 text-[16px] text-textSubtitle">
              Disfruta tu servicio sin compromisos y con total flexibilidad.
            </p>

            <div className="flex justify-between items-center">
              <h4 className="text-[18px] text-blue-600 font-semibold">
                $49.900 / Mes
              </h4>
              <button onClick={() => navigate("/user/suscripcion/payment")} className="text-[14px] flex items-center justify-center border-2 border-bgSecundary text-textSecundary font-medium py-2 px-6 rounded-md hover:text-textPrimary hover:border-bgPrimary">
                Actualizar Suscripción
              </button>
            </div>
          </div>

          <div className="border border-gray-300 rounded-md min-w-full overflow-auto h-[54%]">
            <table className="w-full ">
              <thead>
                <tr className="border-b py-4">
                  <th
                    onClick={() => sortData("numero")}
                    className="py-4 pl-6 text-left text-[14px] text-textSubtitle font-semibold cursor-pointer px-4"
                  >
                    Factura{" "}
                    {sortConfig?.key === "numero" &&
                      (sortConfig.direction === "asc" ? (
                        <AiOutlineArrowUp />
                      ) : (
                        <AiOutlineArrowDown />
                      ))}
                  </th>
                  <th
                    onClick={() => sortData("fecha")}
                    className="cursor-pointer text-center text-[14px] text-textSubtitle font-semibold"
                  >
                    Fecha de Factura{" "}
                    {sortConfig?.key === "fecha" &&
                      (sortConfig.direction === "asc" ? (
                        <AiOutlineArrowUp />
                      ) : (
                        <AiOutlineArrowDown />
                      ))}
                  </th>
                  <th className="text-center text-[14px] text-textSubtitle font-semibold">Estado</th>
                  <th
                    onClick={() => sortData("cantidad")}
                    className="cursor-pointer text-center text-[14px] text-textSubtitle font-semibold"
                  >
                    Cantidad{" "}
                    {sortConfig?.key === "cantidad" &&
                      (sortConfig.direction === "asc" ? (
                        <AiOutlineArrowUp />
                      ) : (
                        <AiOutlineArrowDown />
                      ))}
                  </th>
                  <th className="text-center text-[14px] text-textSubtitle font-semibold">Suscripción</th>
                  <th className="text-center text-[14px] text-textSubtitle font-semibold">Descargar</th>
                </tr>
              </thead>
              <tbody>
                {facturas.map((factura, index) => (
                  <tr key={index} className="border-b hover:bg-gray-100 py-4">
                    <td className="py-4 pl-6 text-left text-[14px] text-textTipic font-medium">{factura.numero}</td>
                    <td className="text-center text-[14px] text-textTipic font-medium">{factura.fecha}</td>
                    <td className="text-center text-[14px] text-textTipic font-medium">
                      <span
                        className={`inline-block px-4 py-1 rounded-full text-white text-[12px] ${
                          factura.estado === "Pagado"
                            ? "bg-[#E5FFE1] text-[#1E9609]"
                            : "bg-[#FFF0F0] text-[#A70909]"
                        }`}
                      >
                        {factura.estado}
                      </span>
                    </td>
                    <td className="text-center text-[14px] text-textTipic font-medium">{factura.cantidad}</td>
                    <td className="text-center text-[14px] text-textTipic font-medium">{factura.suscripcion}</td>
                    <td className="text-center text-[14px] text-textTipic font-medium">
                      <button className="text-blue-600">
                        <AiOutlineDownload size={20} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuscripcionTransaccion;
